var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('popover-text',{style:([_vm.popoverStyle]),attrs:{"line":1,"text":_vm.getText,"colType":_vm.colType,"tableData":_vm.tableData,"scope":_vm.scope,"disabled":_vm.disabled,"subText":_vm.getSubtext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }